import translationUtils from './utility';
import { LYRIC } from '../constants';
import Parser from 'html-react-parser';

class Translator {
  constructor(namespace, dictionary = {}) {
    this.namespace = namespace;
    this.dictionary = dictionary;
  }

  translateKey(dictionary, fullKey, isRebrandEnabled) {
    const useEvaltaBranding = window.location.hostname.includes('evalta');
    const useNewBranding = window.location.hostname.includes('lyric');

    let translatedText = dictionary[fullKey];

    if (translatedText && translatedText.includes('2000-2024')) {
      const currentYear = new Date().getFullYear();

      translatedText = translatedText.replace('2000-2024', `2000-${currentYear}`);
    }

    if (useEvaltaBranding && translatedText) {
      return translatedText.replace('Lifion', 'Evalta');
    }

    if ((useNewBranding || isRebrandEnabled) && translatedText) {
      return translatedText.replaceAll('Lifion', LYRIC).replace('Next Gen', 'Lyric');
    }
    return translatedText;
  }

  getFullKey(key) {
    const namespace = !this.namespace ? '' : `${this.namespace}.`;

    return `${namespace}${key}`;
  }

  getStringUsingInterpolationStrategy(
    key,
    dictionary,
    params,
    interpolationStrategy,
    isRebrandEnabled
  ) {
    const fallbackTranslatedText = !key ? `${key}` : `**${key}**`; //this is to fail i18n tests when key does not exist
    const chosenDictionary = dictionary || this.dictionary;

    try {
      const fullKey = this.getFullKey(key);
      const translatedText = this.translateKey(chosenDictionary, fullKey, isRebrandEnabled);

      if (!translatedText) {
        return fallbackTranslatedText;
      }

      if (params) {
        return interpolationStrategy(translatedText, params);
      }

      return translatedText;
    } catch (e) {
      return fallbackTranslatedText;
    }
  }

  getReactRenderedString(key, dictionary, params, isRebrandEnabled) {
    return this.getStringUsingInterpolationStrategy(
      key,
      dictionary,
      params,
      translationUtils.interpolateWithReactObjects,
      isRebrandEnabled
    );
  }

  get(key, dictionary, params, isRebrandEnabled) {
    return this.getStringUsingInterpolationStrategy(
      key,
      dictionary,
      params,
      translationUtils.interpolate,
      isRebrandEnabled
    );
  }

  getHtml(key, dictionary, params, isRebrandEnabled) {
    const chosenDictionary = dictionary || this.dictionary;

    return Parser(this.get(key, chosenDictionary, params, isRebrandEnabled));
  }
}

export { Translator as default };
